define('webshopMenuHistoryView',[
  'module',
  'marionette',
  'underscore',
  'entities/webshop/menu',
  'template!webshopMenuHistoryView'
], function (
  Module,
  Marionette,
  _,
  MenuApi,
  Tpl
) {
  'use strict';

  // Content of a ModalView: versions of the menu of options.locale; the chosen one goes in model.id
  Module.exports = Marionette.ItemView.extend({
    template: Tpl,
    className: 'webshop-menu-history-view',

    ui: {
      list: '.mm-history-list'
    },

    events: {
      'click .mm-history-item': 'onSelect'
    },

    onShow: function () {
      MenuApi.history(this.options.locale).done(_.bind(this.renderList, this)).fail(_.bind(function (message) {
        this.ui.list.text(message);
      }, this));
    },

    renderList: function (versions) {
      if (this.isDestroyed)
        return;
      var e = _.escape;
      var html = '';
      _.each(versions, function (v) {
        html += '<div class="mm-history-item" data-id="' + e(v.id) + '">' +
          '<div class="mm-history-head">' +
          '<span class="mm-history-id">#' + e(v.id) + '</span>' +
          '<span class="mm-history-date">' + e(this.options.formatDate(v.updatedAt)) + '</span>' +
          '<span class="mm-history-source source-' + e(v.source) + '">' + e(this.options.sourceLabel(v.source)) + '</span>' +
          (v.id === this.options.currentId ? '<span class="mm-history-current">' +
            e(_.i18n('webshop.menu.history.current', null, 'Online')) + '</span>' : '') +
          '<span class="mm-history-size">' + Math.round(v.size / 1024) + ' KB</span>' +
          '</div>' +
          '<div class="mm-history-items">' + e(v.items.join(' · ')) + '</div>' +
          '</div>';
      }, this);
      this.ui.list.html(html || e(_.i18n('webshop.menu.history.empty', null, 'No version')));
    },

    onSelect: function (e) {
      this.$('.mm-history-item').removeClass('selected');
      $(e.currentTarget).addClass('selected');
      this.model.set('id', $(e.currentTarget).data('id'));
    }
  });
});

